import { enrichDatapointWithAppVisibility, logPerformanceDatapoint as logPerformanceDatapointCore, } from "owa-analytics-core";
import type { LogPerformanceDatapointParams } from "owa-analytics-types";
import { getAnalyticsAddon } from "owa-analytics-addons";
import { getThreadName } from "owa-thread-config";
import { queueOrRun } from "owa-analytics-utils";
import { logToTracingPanel } from "../../utils/logToTracingPanel";
import { getAnalyticsFlightsAndAppSettings } from "owa-analytics-core/lib/settings/getAnalyticsFlightsAndAppSettings";
import { isRunningOnWorker } from "owa-config";

export function logPerformanceDatapoint(...[datapoint, status, errorType]: LogPerformanceDatapointParams): void {
    logToTracingPanel(datapoint, status);
    enrichDatapointWithAppVisibility(datapoint);
    
    queueOrRun("logPerformanceDatapoint", logPerformanceDatapointFunction, datapoint, status, errorType);
}

export function logPerformanceDatapointFunction(...[datapoint, status, errorType]: LogPerformanceDatapointParams): void {
    if (getThreadName() === "MAIN_THREAD") {
        getAnalyticsAddon("LogInWorkerOrMainThread")?.executeWhenReady(logPerformanceDatapointCore, "logPerformanceDatapoint", datapoint, status, errorType);
    }
    else {
        logPerformanceDatapointCore(datapoint, status, errorType);
    }
    
    if (!isRunningOnWorker() && getAnalyticsFlightsAndAppSettings()?.devToolsEnabled) {
        getAnalyticsAddon("LogUnifiedTelemetryDiagnostics")?.executeWhenReady(datapoint);
    }
}
